import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export function fillMissingDates({
  items,
  from,
  to,
  emptyItem,
  itemFormat,
  rangeFormat,
  outputFormat = 'YYYY-MM-DD HH:mm:ssZ',
  inclusiveEnd = false,
}) {
  const parseUTCFlex = (d, fmt) => {
    if (d instanceof Date || typeof d === 'number') return dayjs.utc(d);
    if (typeof d === 'string' && fmt) {
      const t = dayjs.utc(d, fmt, true);
      if (t.isValid()) return t;
    }
    return dayjs.utc(d);
  };

  const normKey = (d) =>
    (itemFormat ? dayjs.utc(d, itemFormat, true) : dayjs.utc(d))
      .startOf('day')
      .format(outputFormat);

  const byDate = new Map();
  for (const it of items || []) {
    const key = normKey(it.date);

    const origSrc = it.originalDate ?? it.date;
    const orig = (typeof origSrc === 'string')
      ? (itemFormat ? dayjs.utc(origSrc, itemFormat, true) : dayjs.utc(origSrc))
      : dayjs.utc(origSrc);
    const originalDate = orig.startOf('day').format(outputFormat);

    byDate.set(key, { ...it, date: key, originalDate });
  }

  const toUTCStartOfDayByLocalDate = (d) => {
    if (d instanceof Date || typeof d === 'number') {
      const dayStr = dayjs(d).format('YYYY-MM-DD');
      return dayjs.utc(dayStr, 'YYYY-MM-DD');
    }
    return parseUTCFlex(d, rangeFormat).startOf('day');
  };

  const start = toUTCStartOfDayByLocalDate(from);
  let end = toUTCStartOfDayByLocalDate(to);
  if (inclusiveEnd) end = end.add(1, 'day');

  const result = [];
  for (let cur = start; cur.isBefore(end); cur = cur.add(1, 'day')) {
    const key = cur.format(outputFormat);
    result.push(byDate.get(key) || { ...emptyItem, date: key, originalDate: key });
  }

  return result;
}
